import { gettext } from '@eventbrite/i18n';
import React from 'react';

export type RefundPolicyProps = {
    isEnableRetainFeeActive: boolean;
    isPaidEvent: boolean;
    isRefundRequestAllowed: boolean;
    refundPolicyDescription: string;
    refundPolicyIsNoRefunds: boolean;
};

export const RefundPolicy = ({
    isEnableRetainFeeActive,
    isPaidEvent,
    isRefundRequestAllowed,
    refundPolicyDescription,
    refundPolicyIsNoRefunds,
}: RefundPolicyProps) => {
    if (!isPaidEvent) {
        return null;
    }
    const isNonFeeRefundable =
        isEnableRetainFeeActive && !refundPolicyIsNoRefunds;
    const isRequiredContactOrganizer =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        isRefundRequestAllowed;
    const isNonRefunds =
        isEnableRetainFeeActive &&
        !refundPolicyDescription &&
        !isRefundRequestAllowed;
    return (
        <section aria-labelledby="refund-policy-heading">
            <h3
                id="refund-policy-heading"
                className="label-primary normal-case eds-l-mar-bot-2"
            >
                {gettext('Refund policy')}
            </h3>
            <div className="event-details__data">
                {refundPolicyDescription && (
                    <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: refundPolicyDescription.toString(),
                        }}
                    />
                )}
                {isRequiredContactOrganizer && (
                    <p>
                        {gettext('Contact the organizer to request a refund.')}
                    </p>
                )}
                {isNonFeeRefundable && !isNonRefunds && (
                    <p>{gettext("Eventbrite's fee is nonrefundable.")}</p>
                )}
                {isNonRefunds && <p>{gettext('No Refunds')}</p>}
            </div>
        </section>
    );
};
